//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import statBubbleTemplate from '@partials/stat-bubble.html';

(function() {
  angular.module('curalate').component('statBubble', {
    bindings: {
      title: '@',
      icon: '@',
      tt: '@',
      formatter: '=',
      decorate: '=',
      data: '=',
      ttPlacement: '@?',
    },
    template: statBubbleTemplate,
    transclude: {
      secondaryData: '?secondaryData',
    },
    controller: [function() {
      const self = this;
      self.$onInit = () => {
        const fullWrapperEl = angular.element('#full-wrapper')[0];
        self.isFullWrapper = !!fullWrapperEl;
      };
    }],
  });
})();
